const isDev = import.meta.env.DEV;

export const env = {
  DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN,
  CLIENTID: import.meta.env.VITE_AUTH0_CLIENT_ID,
  AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE,
  DEV_BYPASS_AUTH: isDev ? import.meta.env.VITE_DEV_BYPASS_AUTH : undefined,
  JITSI_APP_ID: import.meta.env.VITE_JITSI_APP_ID,
  OPENROUTER_API_KEY: isDev ? import.meta.env.VITE_OPENROUTER_API_KEY : undefined,
  TINYMCE_API_KEY: import.meta.env.VITE_TINYMCE_API_KEY,
  YOUTUBE_API_KEY: import.meta.env.VITE_YOUTUBE_API_KEY
};
